import { render } from "./SlotsExerciseSingleDestination.vue?vue&type=template&id=cc1ffa00&scoped=true&ts=true"
import script from "./SlotsExerciseSingleDestination.vue?vue&type=script&lang=ts"
export * from "./SlotsExerciseSingleDestination.vue?vue&type=script&lang=ts"

import "./SlotsExerciseSingleDestination.vue?vue&type=style&index=0&id=cc1ffa00&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc1ffa00"]])

export default __exports__